﻿import type { User } from '@/types';

export const mockUsers: User[] = [
  {
    id: 'admin-001',
    name: 'AdministraÃ§Ã£o',
    cpf: 'ADM001',
    email: 'admin@portal.com',
    setor: 'Administrativo',
    perfil: 'admin',
    status: 'ativo',
    createdAt: '2024-01-01T00:00:00Z',
  },
  {
    id: 'colab-001',
    name: 'JoÃ£o Silva',
    cpf: 'COL001',
    email: 'joao.silva@portal.com',
    setor: 'ProduÃ§Ã£o',
    perfil: 'colaborador',
    status: 'ativo',
    createdAt: '2024-01-15T00:00:00Z',
  },
  {
    id: 'colab-002',
    name: 'Maria Santos',
    cpf: 'COL002',
    email: 'maria.santos@portal.com',
    setor: 'LaboratÃ³rio',
    perfil: 'colaborador',
    status: 'ativo',
    createdAt: '2024-02-01T00:00:00Z',
  },
  {
    id: 'colab-003',
    name: 'Pedro Oliveira',
    cpf: 'COL003',
    email: 'pedro.oliveira@portal.com',
    setor: 'ETA',
    perfil: 'colaborador',
    status: 'inativo',
    createdAt: '2024-03-01T00:00:00Z',
  },
];
